import React, { Component } from "react";
import { Container, Typography, Grid } from "@material-ui/core";
import { PostData } from "../api/service";
import BreadCrumbOwn from "../component/Essentials/BreadCrumbOwn";
import { Button } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  FileTextOutlined,
  DownloadOutlined,
  ArrowLeftOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import queryString from "query-string";
import Gallery from "react-grid-gallery";

const GREEN = "#0B3D2E";
const ACCENT = "#1E7A52";

export default class SingleEvent extends Component {
  state = {
    data: null,
    isLoaded: false,
    photos: [],
    files: [],
  };

  __loadFile = (eventId) => {
    this.setState({ isLoaded: false });

    PostData(`/getsingleeventbyid`, { eventId }).then((resp) => {
      if (resp != false) {
        let photos = [];
        let files = [];

        let upload_info = resp.upload_info;
        if (Array.isArray(upload_info)) {
          upload_info.forEach((el) => {
            if (el.fileType == "image") photos.push(el);
            if (el.fileType == "file") files.push(el);
          });
        }

        this.setState({ data: resp, photos, files, isLoaded: true });
      } else {
        this.props.history.push("/events");
      }
    });
  };

  componentDidMount() {
    let q = queryString.parse(this.props.history.location.search);
    if (q && q.eventId) {
      this.__loadFile(q.eventId);
    }
  }

  render() {
    const { data, isLoaded, photos, files } = this.state;
    const featured =
      data && Array.isArray(data.featured_photo) && data.featured_photo.length > 0
        ? data.featured_photo[0].url
        : photos.length > 0
        ? photos[0].url
        : null;

    return (
      <div style={{ backgroundColor: "#F4F6F6", minHeight: "100vh" }}>
        <BreadCrumbOwn title="Event" />

        <Container maxWidth="md" style={{ paddingTop: 30, paddingBottom: 60 }}>
          {!isLoaded ? (
            <div style={{ textAlign: "center", padding: "80px 0", color: "#7F8C8D" }}>
              <Typography variant="h6">Loading event . . .</Typography>
            </div>
          ) : data == null ? null : (
            <div
              style={{
                backgroundColor: "white",
                borderRadius: 14,
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              }}
            >
              {/* HERO */}
              {featured ? (
                <div style={{ position: "relative", width: "100%" }}>
                  <img
                    src={featured}
                    alt={data.title}
                    style={{
                      width: "100%",
                      height: 380,
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to bottom, rgba(0,0,0,0) 35%, rgba(0,0,0,0.78) 100%)",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      padding: "24px 28px",
                      color: "white",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        backgroundColor: ACCENT,
                        color: "white",
                        fontWeight: 700,
                        fontSize: 13,
                        padding: "4px 12px",
                        borderRadius: 20,
                        marginBottom: 10,
                      }}
                    >
                      <CalendarOutlined /> &nbsp;
                      {data.date_no} {data.month} {data.year}
                    </span>
                    <Typography
                      variant="h4"
                      style={{
                        fontWeight: 800,
                        lineHeight: 1.2,
                        textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                      }}
                    >
                      {data.title}
                    </Typography>
                  </div>
                </div>
              ) : (
                <div style={{ backgroundColor: GREEN, padding: "34px 28px", color: "white" }}>
                  <span
                    style={{
                      display: "inline-block",
                      backgroundColor: ACCENT,
                      fontWeight: 700,
                      fontSize: 13,
                      padding: "4px 12px",
                      borderRadius: 20,
                      marginBottom: 10,
                    }}
                  >
                    <CalendarOutlined /> &nbsp;
                    {data.date_no} {data.month} {data.year}
                  </span>
                  <Typography variant="h4" style={{ fontWeight: 800, lineHeight: 1.2 }}>
                    {data.title}
                  </Typography>
                </div>
              )}

              {/* BODY */}
              <div style={{ padding: "28px 30px" }}>
                {/* meta row */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 20,
                    alignItems: "center",
                    color: "#566573",
                    fontSize: 14,
                    borderBottom: "1px solid #ECF0F1",
                    paddingBottom: 16,
                    marginBottom: 20,
                  }}
                >
                  <span>
                    <UserOutlined style={{ color: ACCENT }} /> &nbsp;
                    Posted by <strong style={{ color: "#2C3E50" }}>{data.posted_as}</strong>
                  </span>
                  <span>
                    <CalendarOutlined style={{ color: ACCENT }} /> &nbsp;
                    {data.day}, {data.date}
                  </span>
                </div>

                {/* description */}
                <Typography
                  variant="body1"
                  component="div"
                  style={{ color: "#34495E", lineHeight: 1.8, fontSize: 16 }}
                  dangerouslySetInnerHTML={{ __html: data.description }}
                />

                {/* attachments */}
                {Array.isArray(files) && files.length > 0 && (
                  <div style={{ marginTop: 34 }}>
                    <SectionTitle icon={<FileTextOutlined />} text="Attachments" />
                    <Grid container spacing={2} style={{ marginTop: 4 }}>
                      {files.map((el, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <a
                            href={el.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                border: "1px solid #E5E8E8",
                                borderRadius: 10,
                                padding: "12px 14px",
                                background: "#FBFCFC",
                              }}
                            >
                              <div
                                style={{
                                  background: ACCENT,
                                  color: "white",
                                  borderRadius: 8,
                                  width: 40,
                                  height: 40,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: 18,
                                  flexShrink: 0,
                                }}
                              >
                                <FileTextOutlined />
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  style={{
                                    color: "#2C3E50",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {el.path}
                                </div>
                                <div style={{ color: "#95A5A6", fontSize: 12 }}>
                                  Click to open / download
                                </div>
                              </div>
                              <DownloadOutlined style={{ color: ACCENT, fontSize: 18 }} />
                            </div>
                          </a>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                )}

                {/* gallery */}
                {Array.isArray(photos) && photos.length > 0 && (
                  <div style={{ marginTop: 34 }}>
                    <SectionTitle
                      icon={<PictureOutlined />}
                      text={`Photo Gallery (${photos.length})`}
                    />
                    <div style={{ marginTop: 10, overflow: "hidden" }}>
                      <Gallery
                        enableImageSelection={false}
                        images={photos.map((el1) => ({
                          src: el1.url,
                          thumbnail: el1.url,
                          thumbnailWidth: 300,
                          thumbnailHeight: 220,
                        }))}
                      />
                    </div>
                  </div>
                )}

                {/* footer */}
                <div style={{ marginTop: 36, borderTop: "1px solid #ECF0F1", paddingTop: 20 }}>
                  <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => this.props.history.push("/events")}
                    style={{
                      background: GREEN,
                      color: "white",
                      border: "none",
                      fontWeight: 600,
                    }}
                  >
                    Back to Events
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const SectionTitle = ({ icon, text }) => (
  <Typography
    variant="h6"
    style={{
      fontWeight: 700,
      fontSize: 16,
      color: "#0B3D2E",
      display: "flex",
      alignItems: "center",
      gap: 8,
      borderLeft: "4px solid #1E7A52",
      paddingLeft: 10,
    }}
  >
    {icon} {text}
  </Typography>
);
